// React
import React from 'react';
// PropType
import PropTypes from 'prop-types';
// translation
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
// MUI
import { Paper, Typography, Box, Grid, Avatar } from '@material-ui/core';
// Images
import CompanyIcon from 'aurora-images/Company_avatar.svg';
// styles
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import styles from './styles';
// Components
import { ADGMItemDetails } from '../../components';

const DeveloperDetails = ({ classes, developer, showEmail }) => {
  const locale = localStorage.getItem('lang');
  const GenericDeveloperDetails = {
    ...developer,
    nameAr: developer?.ownerNameAr ?? developer?.developerNameAr ?? '~',
    nameEn: developer?.ownerNameEn ?? developer?.developerNameEn ?? '~',
  };

  return (
    <Paper variant='outlined' className={classes.marginBottom}>
      <div className={classes.titleHead}>
        <Typography variant='h6' component='h1' className={classes.title}>
          <FormattedMessage {...messages.developer_details} />
        </Typography>
      </div>
      <Box className={classNames(classes.innerCard)}>
        <Grid container spacing={2} className={classes.container}>
          <Grid item xs={12} sm={4}>
            <Box className={classes.developerDetailsBox}>
              <Avatar alt='DeveloperDetails' src={CompanyIcon} style={{ width: 60, height: 60 }} />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                <Typography variant='body1' className={classes.label}>
                  <ADGMItemDetails
                    label={<FormattedMessage {...messages.developer_name} />}
                    value={
                      locale === 'en' ? GenericDeveloperDetails?.nameEn ?? '~' : GenericDeveloperDetails?.nameAr ?? '~'
                    }
                  />
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={8}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant='body1' className={classes.label}>
                  <ADGMItemDetails
                    label={<FormattedMessage {...messages.Trade_license_number} />}
                    value={GenericDeveloperDetails?.tradeLicenseNumber ?? '~'}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant='body1' className={classes.label}>
                  <ADGMItemDetails
                    label={<FormattedMessage {...messages.registration_license_number} />}
                    value={GenericDeveloperDetails?.registrationLicenseNumber ?? '~'}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant='body1' className={classes.label}>
                  <ADGMItemDetails
                    label={<FormattedMessage {...messages.Phone_Number} />}
                    value={GenericDeveloperDetails?.phoneNumber ?? '~'}
                  />
                </Typography>
              </Grid>
              {showEmail && (
                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' className={classes.label}>
                    <ADGMItemDetails
                      label={<FormattedMessage {...messages.email} />}
                      value={GenericDeveloperDetails?.email ?? '~'}
                    />
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

DeveloperDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  developer: PropTypes.object.isRequired,
  showEmail: PropTypes.bool,
};

DeveloperDetails.defaultProps = {
  showEmail: false,
};

export default withStyles(styles)(DeveloperDetails);
